import Check from "./check.view";

export default Check;
